import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 420);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Back to top"
      className="fixed z-50 flex items-center gap-2 cursor-pointer whitespace-nowrap"
      style={{
        bottom: '5.5rem',
        right: '1.25rem',
        // Fade + slide in/out
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
        pointerEvents: visible ? 'auto' : 'none',
        transition: 'opacity 0.25s ease, transform 0.25s ease',
        // Pill shape
        height: '2.5rem',
        borderRadius: '9999px',
        padding: hovered ? '0 1rem 0 0.75rem' : '0 0.625rem',
        background: 'oklch(var(--primary-500))',
        boxShadow: '0 4px 14px rgba(0,0,0,0.22)',
        border: 'none',
        overflow: 'hidden',
        maxWidth: hovered ? '9rem' : '2.5rem',
        // Pill expansion on hover
        transitionProperty: 'opacity, transform, max-width, padding',
        transitionDuration: '0.25s',
        transitionTimingFunction: 'ease',
      }}
    >
      {/* Arrow icon — always visible */}
      <span
        className="flex items-center justify-center flex-shrink-0"
        style={{ width: '1.25rem', height: '1.25rem' }}
      >
        <i className="ri-arrow-up-line text-white text-base" />
      </span>

      {/* Label — slides in on hover */}
      <span
        className="text-white font-semibold text-xs"
        style={{
          opacity: hovered ? 1 : 0,
          maxWidth: hovered ? '6rem' : '0',
          transition: 'opacity 0.2s ease 0.05s, max-width 0.25s ease',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
      >
        Back to top
      </span>
    </button>
  );
}